
import React, { useState } from 'react';
import './ParcelStatusPage.css';
import NavBar from '../../Components/NavBarSec/NavBar';
import Footer from '../../Components/Foooter/Footer';
import Operation from '../../Components/Operation/Operation';
import ScrollToTop from '../../Components/Scrolltop/Scrolltop';
import useContentful from '../../Hooks/Contentful';

const ParcelStatusPage = () => {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [orderDetails, setOrderDetails] = useState(null);
  const { getOrders } = useContentful(); // Assuming this fetches order details by tracking number

  const handleTrackingSubmit = async (e) => {
    e.preventDefault();

    // Fetch all orders and filter for the one with the matching reference
    const orders = await getOrders();
    const foundOrder = orders.find(order => order.reference === trackingNumber);

    if (foundOrder) {
      setOrderDetails(foundOrder);
    } else {
      alert("Tracking number not found.");
      setOrderDetails(null);
    }
  };

  // const progressPercentage = orderDetails ? Math.round(
  //   (orderDetails.deliverySteps.filter(step => step.completed).length / orderDetails.deliverySteps.length) * 100
  // ) : 0;

  return (
    <>
      <div className="NavSecContainerProd">
        <NavBar />
        <ScrollToTop />
      </div>

      <div className="parcel-status-page">
        <h2>Parcel Tracking</h2>

        {/* Tracking Input Form */}
        <form onSubmit={handleTrackingSubmit}>
          <input
            type="text"
            placeholder="Enter Tracking Number"
            value={trackingNumber}
            onChange={(e) => setTrackingNumber(e.target.value)}
            required
          />
          <button type="submit">Track</button>
        </form>

        {/* Order Details Section */}
        {orderDetails && (
          <section className="order-details">
            <h3>Order Details</h3>
            <p><strong>Order Number:</strong> {orderDetails.reference || "N/A"}</p>
            <p><strong>Client Name:</strong> {orderDetails.clientName || "N/A"}</p>
            <p><strong>Order Date:</strong> {orderDetails.createdAt || "N/A"}</p>
            <p><strong>Size:</strong> {orderDetails.size || "N/A"}</p>
            <p><strong>Color:</strong> {orderDetails.color || "N/A"}</p>
            <p><strong>Items:</strong> {orderDetails.title || "N/A"}</p>
            <p><strong>Quantity:</strong> {orderDetails.quantity || "N/A"}</p>
            <p><strong>Recipient Address:</strong> {orderDetails.recipientAddress || "N/A"}</p>
            <p><strong>Estimated Delivery:</strong> {orderDetails.estimatedDeliveryDate || "N/A"}</p>
            <p><strong>Cost:</strong> ZMK{parseFloat(orderDetails.cost).toFixed(2) || "N/A"}</p>
          </section>
        )}

        {/* Payment Status Section */}
        {orderDetails && (
          <section className={`payment-status ZMK{orderDetails.paymentstatus && orderDetails.paymentstatus.toLowerCase() === "completed" ? "completed" : "pending"}`}>
            <h3>Payment Status: {orderDetails.paymentstatus || "N/A"}</h3>
          </section>
        )}

        {/* Delivery Progress Bar */}
        {orderDetails && (
          <section className="progress-bar">
            <h3>Delivery Progress</h3>
            <div className="progress">
              <div className="progress-filled" style={{ width: `ZMK{60}%` }}></div>
            </div>
            <p>{60}% Complete</p>
            {/* <div className="progress">
              <div className="progress-filled" style={{ width: `ZMK{progressPercentage}%` }}></div>
            </div>
            <p>{progressPercentage}% Complete</p> */}
          </section>
        )}

        {/* Delivery Status Section */}
        {orderDetails && (
          <section className="delivery-status">
            <h3>Delivery Status</h3>
            <div className="steps">
              {/* {orderDetails.deliverySteps.map((step, index) => (
                <div key={index} className={`step ZMK{step.completed ? "completed" : ""}`}>
                  <div className="step-label">{step.label}</div>
                  <div className="timestamp">{step.timestamp || "Pending"}</div>
                </div>
              ))} */}
            </div>
          </section>
        )}

        {/* Pricing Details Section */}
        {orderDetails && (
          <section className="pricing-details">
            <h3>Pricing Details</h3>
            <p><strong>Subtotal:</strong> ZMK{parseFloat(orderDetails.cost).toFixed(2) || "N/A"}</p>
            <p><strong>Delivery Fee:</strong> ZMK{"N/A"}</p> {/* Assuming delivery fee is not provided */}
            <p><strong>Tax:</strong> ZMK{"N/A"}</p> {/* Assuming tax is not provided */}
            <p><strong>Total:</strong> ZMK{parseFloat(orderDetails.totalpay).toFixed(2) || "N/A"}</p>
          </section>
        )}

        {/* Support Section */}
        <section className="support">
          <h3>Need Help?</h3>
          <p>If you have questions or need assistance, please contact us:</p>
          <p><strong>Email:</strong> blessinglombe@gmail.com</p>
          <p><strong>Phone:</strong> +260971873484</p>
          <p><a href="/">Visit our FAQ</a> for more details.</p>
        </section>
      </div>

      <Operation />
      <Footer />
    </>
  );
};

export default ParcelStatusPage;


// import React, { useState } from 'react';
// import './ParcelStatusPage.css';
// import NavBar from '../../Components/NavBarSec/NavBar';
// import Footer from '../../Components/Foooter/Footer';
// import Operation from '../../Components/Operation/Operation';
// import ScrollToTop from '../../Components/Scrolltop/Scrolltop';

// const ParcelStatusPage = () => {
//   const [trackingNumber, setTrackingNumber] = useState('');
//   const [orderDetails, setOrderDetails] = useState(null);

//   const mockOrderDetails = {
//     orderNumber: "123456789",
//     clientName: "John Doe",
//     orderDate: "2024-10-20",
//     items: ["Item 1", "Item 2"],
//     recipientAddress: "123 Main St, Anytown, USA",
//     paymentStatus: "Completed",
//     estimatedDeliveryDate: "2024-10-25",
//     deliverySteps: [
//       { label: "Order Placed", timestamp: "2024-10-20 10:00 AM", completed: true },
//       { label: "Dispatched", timestamp: "2024-10-21 02:00 PM", completed: true },
//       { label: "In Transit", timestamp: "2024-10-22 08:00 AM", completed: true },
//       { label: "Out for Delivery", timestamp: "", completed: false },
//       { label: "Delivered", timestamp: "", completed: false },
//     ],
//     pricingDetails: {
//       subtotal: 49.99,
//       deliveryFee: 5.00,
//       tax: 2.50,
//       total: 57.49,
//     },
//   };

//   const handleTrackingSubmit = (e) => {
//     e.preventDefault();
//     // Simulating fetching order details based on tracking number
//     if (trackingNumber === "123456789") {
//       setOrderDetails(mockOrderDetails);
//     } else {
//       alert("Tracking number not found.");
//       setOrderDetails(null);
//     }
//   };

//   const progressPercentage = orderDetails ? Math.round(
//     (orderDetails.deliverySteps.filter(step => step.completed).length / orderDetails.deliverySteps.length) * 100
//   ) : 0;

//   return (

//     <>    

//         <div className="NavSecContainerProd">
//            <NavBar />
//            <ScrollToTop/>
//       </div>

// <div className="parcel-status-page">
      
//       <h2>Parcel Tracking</h2>

//       {/* Tracking Input Form */}
//       <form onSubmit={handleTrackingSubmit}>
//         <input
//           type="text"
//           placeholder="Enter Tracking Number"
//           value={trackingNumber}
//           onChange={(e) => setTrackingNumber(e.target.value)}
//           required
//         />
//         <button type="submit">Track</button>
//       </form>

//       {/* Order Details Section */}
//       {orderDetails && (
//         <section className="order-details">
//           <h3>Order Details</h3>
//           <p><strong>Order Number:</strong> {orderDetails.orderNumber}</p>
//           <p><strong>Client Name:</strong> {orderDetails.clientName}</p>
//           <p><strong>Order Date:</strong> {orderDetails.orderDate}</p>
//           <p><strong>Items:</strong> {orderDetails.items.join(", ")}</p>
//           <p><strong>Recipient Address:</strong> {orderDetails.recipientAddress}</p>
//           <p><strong>Estimated Delivery:</strong> {orderDetails.estimatedDeliveryDate}</p>
//         </section>
//       )}

//       {/* Payment Status Section */}
//       {orderDetails && (
//         <section className={`payment-status ZMK{orderDetails.paymentStatus === "Completed" ? "completed" : "pending"}`}>
//           <h3>Payment Status: {orderDetails.paymentStatus}</h3>
//         </section>
//       )}

//       {/* Delivery Progress Bar */}
//       {orderDetails && (
//         <section className="progress-bar">
//           <h3>Delivery Progress</h3>
//           <div className="progress">
//             <div className="progress-filled" style={{ width: `ZMK{progressPercentage}%` }}></div>
//           </div>
//           <p>{progressPercentage}% Complete</p>
//         </section>
//       )}

//       {/* Delivery Status Section */}
//       {orderDetails && (
//         <section className="delivery-status">
//           <h3>Delivery Status</h3>
//           <div className="steps">
//             {orderDetails.deliverySteps.map((step, index) => (
//               <div key={index} className={`step ZMK{step.completed ? "completed" : ""}`}>
//                 <div className="step-label">{step.label}</div>
//                 <div className="timestamp">{step.timestamp || "Pending"}</div>
//               </div>
//             ))}
//           </div>
//         </section>
//       )}

//       {/* Pricing Details Section */}
//       {orderDetails && (
//         <section className="pricing-details">
//           <h3>Pricing Details</h3>
//           <p><strong>Subtotal:</strong> ZMK{orderDetails.pricingDetails.subtotal.toFixed(2)}</p>
//           <p><strong>Delivery Fee:</strong> ZMK{orderDetails.pricingDetails.deliveryFee.toFixed(2)}</p>
//           <p><strong>Tax:</strong> ZMK{orderDetails.pricingDetails.tax.toFixed(2)}</p>
//           <p><strong>Total:</strong> ZMK{orderDetails.pricingDetails.total.toFixed(2)}</p>
//         </section>
//       )}

//       {/* Support Section */}
//       <section className="support">
//         <h3>Need Help?</h3>
//         <p>If you have questions or need assistance, please contact us:</p>
//         <p><strong>Email:</strong> support@example.com</p>
//         <p><strong>Phone:</strong> +1 (555) 123-4567</p>
//         <p><a href="/faq">Visit our FAQ</a> for more details.</p>
//       </section>
//     </div>

//       <Operation/>
//        <Footer/>
      
      
//     </>
  
//   );
// };

// export default ParcelStatusPage;

// import React from 'react';
// import './ParcelStatusPage.css';
// import NavBar from '../../Components/NavBarSec/NavBar';

// const ParcelStatusPage = () => {
//   const orderDetails = {
//     orderNumber: "123456789",
//     clientName: "John Doe",
//     orderDate: "2024-10-20",
//     items: ["Item 1", "Item 2"],
//     recipientAddress: "123 Main St, Anytown, USA",
//   };

//   const paymentStatus = "Completed";
//   const estimatedDeliveryDate = "2024-10-25";
//   const deliverySteps = [
//     { label: "Order Placed", timestamp: "2024-10-20 10:00 AM", completed: true },
//     { label: "Dispatched", timestamp: "2024-10-21 02:00 PM", completed: true },
//     { label: "In Transit", timestamp: "2024-10-22 08:00 AM", completed: true },
//     { label: "Out for Delivery", timestamp: "", completed: false },
//     { label: "Delivered", timestamp: "", completed: false },
//   ];

//   const progressPercentage = Math.round(
//     (deliverySteps.filter(step => step.completed).length / deliverySteps.length) * 100
//   );

//   const pricingDetails = {
//     subtotal: 49.99,
//     deliveryFee: 5.00,
//     tax: 2.50,
//     total: 57.49,
//   };

//   return (
//     <div className="parcel-status-page">

// <div className="NavSecContainerProd">
//         <NavBar />
//       </div>
//       <h2>Parcel Tracking</h2>

//       {/* Order Details Section */}
//       <section className="order-details">
//         <h3>Order Details</h3>
//         <p><strong>Order Number:</strong> {orderDetails.orderNumber}</p>
//         <p><strong>Client Name:</strong> {orderDetails.clientName}</p>
//         <p><strong>Order Date:</strong> {orderDetails.orderDate}</p>
//         <p><strong>Items:</strong> {orderDetails.items.join(", ")}</p>
//         <p><strong>Recipient Address:</strong> {orderDetails.recipientAddress}</p>
//         <p><strong>Estimated Delivery:</strong> {estimatedDeliveryDate}</p>
//       </section>

//       {/* Payment Status Section */}
//       <section className={`payment-status ZMK{paymentStatus === "Completed" ? "completed" : "pending"}`}>
//         <h3>Payment Status: {paymentStatus}</h3>
//       </section>

//       {/* Delivery Progress Bar */}
//       <section className="progress-bar">
//         <h3>Delivery Progress</h3>
//         <div className="progress">
//           <div className="progress-filled" style={{ width: `ZMK{progressPercentage}%` }}></div>
//         </div>
//         <p>{progressPercentage}% Complete</p>
//       </section>

//       {/* Delivery Status Section */}
//       <section className="delivery-status">
//         <h3>Delivery Status</h3>
//         <div className="steps">
//           {deliverySteps.map((step, index) => (
//             <div key={index} className={`step ZMK{step.completed ? "completed" : ""}`}>
//               <div className="step-label">{step.label}</div>
//               <div className="timestamp">{step.timestamp || "Pending"}</div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Pricing Details Section */}
//       <section className="pricing-details">
//         <h3>Pricing Details</h3>
//         <p><strong>Subtotal:</strong> ZMK{pricingDetails.subtotal.toFixed(2)}</p>
//         <p><strong>Delivery Fee:</strong> ZMK{pricingDetails.deliveryFee.toFixed(2)}</p>
//         <p><strong>Tax:</strong> ZMK{pricingDetails.tax.toFixed(2)}</p>
//         <p><strong>Total:</strong> ZMK{pricingDetails.total.toFixed(2)}</p>
//       </section>

//       {/* Support Section */}
//       <section className="support">
//         <h3>Need Help?</h3>
//         <p>If you have questions or need assistance, please contact us:</p>
//         <p><strong>Email:</strong> support@example.com</p>
//         <p><strong>Phone:</strong> +1 (555) 123-4567</p>
//         <p><a href="/faq">Visit our FAQ</a> for more details.</p>
//       </section>
//     </div>
//   );
// };

// export default ParcelStatusPage;